import { useEffect } from "react";

import "./Bill.css";
import { NewCircleButton } from "./nextButton";

import Image26 from "../Assets/1-26.png";
import Image20 from "../Assets/1-20.png";
import Image2 from "../Assets/1-02.png";
import { ReactComponent as Image16 } from "../Assets/svg/Beauty, Earth and Planet Elements-16.svg";
import { ReactComponent as Image17 } from "../Assets/svg/Beauty, Earth and Planet Elements-17.svg";

// bill component
export const Bill = ({ showImpactVal, button }) => {
  useEffect(() => {
  }, []);

  return (
    <div className="bill-page-container">
      <div className="paper-holder">
        <div className="paper">
          <div className="q-head-icon bill-image-two ">
            <Image17 className="svgIcon " />
          </div>
          <div className="q-head-icon bill-image-one ">
            <Image16 className="svgIcon" />
          </div>
          <div className="paper-data">
            {/* image logo */}
            <img src={Image20} className="bill-logo" alt="imagelogo"></img>

            {/* dotted line */}
            <div className="dashed-line bill-dashed-line">
              <img src={Image2} className="star" alt="star"></img>
            </div>
            {/* bill data  */}
            <p className="bill-heading">Nasties Collected</p>
            <div className="bill-data-holder">
              <div className="bill-data">
                Plastic
                <div className="bill-mid-line"></div>
                <p>{showImpactVal.plastic} g</p>
              </div>
              <div className="bill-data">
                Co2
                <div className="bill-mid-line"></div>
                <p>{showImpactVal.carbon} kg</p>
              </div>
              <div className="bill-data">
                Sulphate
                <div className="bill-mid-line"></div>
                <p>{showImpactVal.sulphate} g</p>
              </div>
              <div className="bill-data">
                Non-Biodegradable
                <div className="bill-mid-line"></div>
                <p>{showImpactVal.non_bio} g</p>
              </div>
            </div>
            {/* comment */}
            <p className="bill-comment">This bill's gonna hurt your dil!</p>
            {/* disclaimer */}
            <p className="bill-disclaimer">
              Disclaimer: These numbers are estimations and not 100% accurate.
              Comparison basis ordinary shampoo bottle
            </p>
            <div className="bill-btn">
              <NewCircleButton position="btn-long-relative" onClick={button} />
            </div>
          </div>
          {/* paper roll */}
          <div className="roll-holder">
            <div className="roll-left">
              <div className="roll-inside"></div>
            </div>
            <div className="roll-center"></div>
            <div className="roll-right"></div>
          </div>
        </div>
      </div>

      {/* footer */}
      <div className="footer-container bill-footer">
        <img src={Image26} className="page-footer" alt="footer"></img>
      </div>
    </div>
  );
};
